import React from 'react';
import ChevronLeftArrow from '../assets/images/ChevronLeft.svg';

export default () => {
  return <img src={ChevronLeftArrow} alt="" />;
};
